var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBorderAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667ZM9.16667 15.8333H5C4.54167 15.8333 4.16667 15.4583 4.16667 15V10.8333H8.33333C8.79167 10.8333 9.16667 11.2083 9.16667 11.6667V15.8333ZM8.33333 9.16667H4.16667V5C4.16667 4.54167 4.54167 4.16667 5 4.16667H9.16667V8.33333C9.16667 8.79167 8.79167 9.16667 8.33333 9.16667ZM15 15.8333H10.8333V11.6667C10.8333 11.2083 11.2083 10.8333 11.6667 10.8333H15.8333V15C15.8333 15.4583 15.4583 15.8333 15 15.8333ZM15.8333 9.16667H11.6667C11.2083 9.16667 10.8333 8.79167 10.8333 8.33333V4.16667H15C15.4583 4.16667 15.8333 4.54167 15.8333 5V9.16667Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderAll);
export default __webpack_public_path__ + "static/media/border_all.ba7a90df58e073accc7808c2aa62bf30.svg";
export { ForwardRef as ReactComponent };